import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { find, upperFirst } from 'lodash';
import moment from 'moment';

import { CompressorActivityStateEnum } from '@/constants/enums';
import { noAlert } from '@/store/Investigation/InvestigationStore';
import { getSeriesColorMapping } from '@/comp/InvestigationDashboard/TabPane/Graph';

import { Date } from './MetricsTooltip';
import { TooltipContainer } from './styled';

const DevicesStatusTooltip = observer(({ x, data, compressors, token }) => {
  const { t } = useTranslation();

  const currentTimeCompressors = data?.map(dataItem => ({
    ...dataItem,
    series: dataItem?.series?.filter(series => moment(series?.x).utc().valueOf() === x),
  }));

  return (
    <TooltipContainer theme={{ token }}>
      <Date date={x} />
      <div className="compressors">
        {currentTimeCompressors?.map(compressor => (
          <React.Fragment key={compressor?.deviceId}>
            <div className="compressor-name">
              <div
                className="compressor-square"
                style={{
                  border:
                    compressor?.series?.[0]?.name === upperFirst(CompressorActivityStateEnum.Unload)
                      ? `0.5px solid ${token.colorBorder}`
                      : null,
                  background:
                    compressor?.series?.[1]?.name && compressor?.series?.[1]?.name !== noAlert
                      ? `linear-gradient(135deg, ${
                          compressor?.series?.[0]?.color ?? getSeriesColorMapping(token)?.['n/a']
                        } 50%,${compressor?.series?.[1]?.color} 50%)`
                      : compressor?.series?.[0]?.color ?? getSeriesColorMapping(token)?.['n/a'],
                }}
              />
              <span>{find(compressors, { id: compressor?.deviceId })?.name}</span>
            </div>
            <span className="compressor-status">
              {compressor?.series?.[0]?.name || t('n/a')}
              {compressor?.series?.[1]?.name && compressor?.series?.[1]?.name !== noAlert
                ? `(${compressor?.series?.[1]?.name})`
                : ''}
            </span>
          </React.Fragment>
        ))}
      </div>
    </TooltipContainer>
  );
});

export default DevicesStatusTooltip;
